function searchRules(app) {
  return {
    ownerEXId: [
      {
        max: 20,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.building.search.query.ownerEXId'),
          length: 20
        }),
        trigger: 'change'
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.building.search.query.ownerEXId'),
          type: '半角英数字'
        })
      }
    ],
    buildingEXId: [
      {
        max: 20,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.building.search.query.buildingEXId'),
          length: 20
        }),
        trigger: 'change'
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.building.search.query.buildingEXId'),
          type: '半角英数字'
        })
      }
    ],
    buildingName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.building.search.query.buildingName'),
          length: 50
        }),
        trigger: 'change'
      }
    ],
    ownerName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.building.search.query.buildingName'),
          length: 50
        }),
        trigger: 'change'
      }
    ]
  }
}

export default {
  searchRules: searchRules
}
